import { HttpRequest } from './HttpRequest'

export const GetDeedProspectByBookingId = async (bookingId: any) => {
    try {
        const response = await HttpRequest().get(`/prospect/deed/bookingId/${bookingId}`)
        if (response.data.message === 'OK') {
            return response.data.responseData
        }
    } catch (error: any) {
        if (error.response.status === 400) return error.response.data.message
        throw new Error('ไม่สามารถโหลดข้อมูลได้ กรุณาลองใหม่')
    }
}

export const GetDeedProspectDetailByProspectId = async (prospectId: string) => {
    try {
        const response = await HttpRequest().get(`/prospect/deed/prospectid/${prospectId}`)
        if (response.data.message === 'OK') {
            return response.data.responseData
        }
    } catch (error: any) {
        if (error.response.status === 400) return error.response.data.message
        throw new Error('ไม่สามารถโหลดข้อมูลได้ กรุณาลองใหม่')
    }
}

export const SearchProspectByName = async (name: string) => {
    try {
        const response = await HttpRequest().get(`/prospect/name/${name}`)
        if (response.data.message === 'OK') {
            const result: any[] = response.data.responseData
            return result
        }
    } catch (error: any) {
        if (error.response.status === 400) return error.response.data.message
        throw new Error('ไม่สามารถโหลดข้อมูลได้ กรุณาลองใหม่')
    }
}

export const UpsertDeedProspect = async (objectDeedProspect: any) => {
    let data = JSON.stringify(objectDeedProspect);
    try {
        const response = await HttpRequest().post(`/prospect/deed/update`, data, {
            headers: {
                'Content-Type': 'application/json'
            }
        })
        if (response.data.message === 'Updated' || response.data.message === 'Created') {
            return "Success"
        }
    } catch (error: any) {
        if (error.response.status === 400) return error.response.data.message
        throw new Error('ไม่สามารถโหลดข้อมูลได้ กรุณาลองใหม่')
    }
}


export const UpdateDeedProspectDetail = async (object: any) => {
    let data = JSON.stringify(object);
    try {
        const response = await HttpRequest().post(`/prospect/deed/update/prospectdetail`, data, {
            headers: {
                'Content-Type': 'application/json'
            }
        })
        if (response.data.message === 'updated') {
            return "updated"
        }
    } catch (error: any) {
        if (error.response.status === 400) return error.response.data.message
        throw new Error('ไม่สามารถโหลดข้อมูลได้ กรุณาลองใหม่')
    }
}